import React from 'react';
import { services, LOGO } from '../mock';
import { ArrowUpRight } from 'lucide-react';
import useReveal from '../hooks/useReveal';

/* Corporate-focused 3D signage props */
function ServiceProp({ prop }) {
  if (prop === 'vinyl') {
    return (
      <div style={{ position: 'relative', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        {/* Wall + peeling vinyl decal */}
        <div className="glass-panel" style={{ width: 130, height: 140, background: 'linear-gradient(135deg, rgba(79,191,184,0.05), rgba(0,0,0,0.15))', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: 14 }}>
          <div className="font-mono" style={{ fontSize: 8, letterSpacing: '0.2em', color: 'var(--teal-light)' }}>GLASS WALL</div>
          <div>
            <div className="font-display" style={{ fontSize: 20, color: 'var(--warm-white)', lineHeight: 1 }}>Meet.</div>
            <div className="font-mono" style={{ fontSize: 8, color: 'var(--smoke)', letterSpacing: '0.2em', marginTop: 4 }}>CONF ROOM · 12F</div>
          </div>
        </div>
        <div className="vinyl-peel" style={{ width: 130, transform: 'rotate(-3deg)' }}>
          <div className="font-mono" style={{ fontSize: 8, letterSpacing: '0.22em', marginBottom: 4 }}>WALL GRAPHIC</div>
          <div className="font-display" style={{ fontSize: 18, lineHeight: 1 }}>UV PRINT<br />READY</div>
          <div style={{ marginTop: 8, height: 2, background: 'var(--warm-white)', width: '70%' }} />
        </div>
      </div>
    );
  }

  if (prop === 'channel') {
    return (
      <div style={{ position: 'relative', height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span className="channel-letter" style={{ fontSize: 90 }}>V</span>
        <span className="channel-letter orange" style={{ fontSize: 80, marginLeft: -4 }}>S</span>
        <span className="channel-letter" style={{ fontSize: 70, marginLeft: -4, opacity: 0.7 }}>T</span>
      </div>
    );
  }

  if (prop === 'monolith') {
    return (
      <div style={{ position: 'relative', height: 180, display: 'flex', justifyContent: 'center', paddingTop: 10, gap: 20 }}>
        <div style={{ position: 'relative', width: 90 }}>
          <div className="monolith" style={{ minHeight: 150, padding: '14px 10px' }}>
            <div style={{ textAlign: 'center' }}>
              <img src={LOGO} alt="" style={{ width: 32, height: 32, borderRadius: 4, background: 'var(--warm-white)', padding: 2, marginBottom: 6 }} />
              <div className="font-mono" style={{ color: 'var(--warm-white)', fontSize: 7, letterSpacing: '0.18em' }}>BLDG A · F1</div>
              <div style={{ height: 1, background: 'rgba(255,255,255,0.3)', margin: '8px auto', width: 30 }} />
              <div className="font-mono" style={{ color: 'var(--orange-2)', fontSize: 7, letterSpacing: '0.18em' }}>→ LOBBY</div>
              <div className="font-mono" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 7, letterSpacing: '0.18em', marginTop: 4 }}>→ EXEC</div>
              <div className="font-mono" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 7, letterSpacing: '0.18em', marginTop: 4 }}>→ BOARD</div>
            </div>
          </div>
          <div className="floor-shadow" style={{ bottom: -14 }} />
        </div>

        <div style={{ position: 'relative', width: 80, alignSelf: 'flex-end' }}>
          <div className="monolith" style={{ minHeight: 110, padding: '12px 8px', background: 'linear-gradient(180deg, var(--orange), var(--orange-dark))' }}>
            <div style={{ textAlign: 'center' }}>
              <div className="font-display" style={{ color: 'var(--warm-white)', fontSize: 14, letterSpacing: '0.1em' }}>WAY</div>
              <div className="font-display" style={{ color: 'var(--warm-white)', fontSize: 14, letterSpacing: '0.1em' }}>FIND</div>
              <div style={{ height: 1, background: 'rgba(255,255,255,0.4)', margin: '6px auto', width: 24 }} />
              <div className="font-mono" style={{ color: 'var(--warm-white)', fontSize: 7, letterSpacing: '0.18em' }}>1/2/3</div>
            </div>
          </div>
          <div className="floor-shadow" style={{ bottom: -14 }} />
        </div>
      </div>
    );
  }

  if (prop === 'lobby') {
    return (
      <div style={{ position: 'relative', height: 180, display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
        <div style={{ position: 'relative', width: 220 }}>
          <div className="chain-sign">
            <div className="chain-bracket left" style={{ top: -46 }} />
            <div className="chain-bracket right" style={{ top: -46 }} />
            <div className="chain left" style={{ top: -40, height: 40 }} />
            <div className="chain right" style={{ top: -40, height: 40 }} />
            <div className="sign-board" style={{ padding: '16px 20px' }}>
              <div style={{ textAlign: 'center' }}>
                <img src={LOGO} alt="" style={{ width: 44, height: 44, borderRadius: 6, background: 'var(--warm-white)', padding: 3, marginBottom: 6 }} />
                <div className="font-mono" style={{ color: 'var(--teal-light)', fontSize: 8, letterSpacing: '0.24em' }}>CORPORATE HQ</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
}

function ServiceCard({ s, i }) {
  const [ref, inView] = useReveal(0.15);
  return (
    <div ref={ref} className={`lift-card reveal delay-${(i % 4) + 1} ${inView ? 'in-view' : ''}`} style={{
      position: 'relative', background: 'var(--ink-2)', border: '1px solid var(--line)',
      padding: 36, overflow: 'hidden', borderRadius: 6,
    }}
    onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.borderColor = 'var(--teal-light)'; e.currentTarget.style.boxShadow = '0 30px 60px -30px rgba(42, 154, 160, 0.4)'; }}
    onMouseLeave={(e) => { e.currentTarget.style.transform = ''; e.currentTarget.style.borderColor = 'var(--line)'; e.currentTarget.style.boxShadow = ''; }}
    >
      <div className="flex justify-between items-start" style={{ marginBottom: 8 }}>
        <div className="font-mono" style={{ color: 'var(--teal-light)', fontSize: 11, letterSpacing: '0.22em' }}>§ {s.num} · {s.tag}</div>
        <ArrowUpRight size={18} color="var(--smoke)" strokeWidth={1.6} />
      </div>

      <div style={{ marginBottom: 16 }}>
        <ServiceProp prop={s.prop} />
      </div>

      <h3 className="font-display" style={{ color: 'var(--paper)', fontSize: 30, marginBottom: 12, letterSpacing: '-0.01em' }}>
        {s.title}
      </h3>
      <p style={{ color: 'var(--smoke)', fontSize: 14, lineHeight: 1.65, marginBottom: 20 }}>{s.desc}</p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 24 }}>
        {s.specs.map((sp) => (
          <span key={sp} className="font-mono" style={{ padding: '5px 10px', border: '1px solid var(--line)', color: 'var(--smoke)', fontSize: 10, letterSpacing: '0.14em', borderRadius: 3 }}>{sp}</span>
        ))}
      </div>

      <a href="#contact" className="ulink">Request Quote →</a>
    </div>
  );
}

export default function Services() {
  const [hRef, hIn] = useReveal(0.1);
  return (
    <section id="services" className="section" ref={hRef} style={{ position: 'relative' }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-8 items-end" style={{ marginBottom: 60 }}>
          <div className={`lg:col-span-7 reveal ${hIn ? 'in-view' : ''}`}>
            <div className="eyebrow" style={{ marginBottom: 24 }}>§ 02 · What We Offer</div>
            <h2 className="section-title">Our <em>services</em>.</h2>
          </div>
          <div className={`lg:col-span-5 reveal delay-2 ${hIn ? 'in-view' : ''}`}>
            <p style={{ color: 'var(--smoke)', fontSize: 15, lineHeight: 1.7 }}>
              The full spectrum of corporate visual branding — from high-resolution printing to nationwide installation and complex turnkey project management.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {services.map((s, i) => <ServiceCard key={s.num} s={s} i={i} />)}
        </div>
      </div>
    </section>
  );
}
